import React, { createContext, useContext, useEffect, useReducer } from "react";
import AppConfigReducer from "../reducers/AppConfigReducer";
import AppConfigService from "../services/AppConfigService";
import { SET_CONFIG, SET_PROPERTY } from "../types/appconfig";
import { ModalContext } from "./ModalContext";

const initialState = {
  online_popup_src: '',
  studio_popup_src: ''
};

export const AppConfigContext = createContext(initialState);

export const AppConfigProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppConfigReducer, initialState);
  const { alert, success } = useContext(ModalContext);

  const getAppConfig = () => {
    AppConfigService.getAppConfig().then((res) => {
      const { config } = res.data;
      dispatch({ type: SET_CONFIG, payload: config });
    });
  };

  const getAdminAppConfig = () => {
    AppConfigService.getAdminAppConfig().then((res) => {
      const { config } = res.data;
      dispatch({ type: SET_CONFIG, payload: config });
    });
  };

  const setAppConfigProperty = (key, value) => {
    dispatch({ type: SET_PROPERTY, payload: { key, value } });
  }

  const updateAppConfig = (data) => {
    return new Promise((resolve, reject) => {
      AppConfigService.updateAppConfig(data).then((res) => {
        const { config } = res.data;
        dispatch({ type: SET_CONFIG, payload: config });
  
        success('¡Configuración Guardada!');
        resolve()
      }).catch(err => {
        alert(err);
        reject()
      });
    });
  }

  return (
    <AppConfigContext.Provider value={{
      ...state, 
      getAppConfig,
      getAdminAppConfig,
      updateAppConfig,
      setAppConfigProperty
    }}>
      {children}
    </AppConfigContext.Provider>
  );
};
